'use strict';
angular.module('imagetrend.components')
    .controller('FormGroupsEditPersonnelModalController', ['$scope', '$uibModalInstance', '$document', 'component', 'group', 'initializeAnswers', 'parameters', 'datapointAnswers', 'pdf', 'completed', 'saving', 'defaultGroup', 'groupForms', 'fromGridEditButton', function ($scope, $uibModalInstance, $document, component, group, initializeAnswers, parameters, datapointAnswers, pdf, completed, saving, defaultGroup, groupForms, fromGridEditButton) {
        $scope.component = component;
        $scope.group = group;
        $scope.initializeAnswers = initializeAnswers;
        $scope.parameters = parameters;
        $scope.datapointAnswers = datapointAnswers;
        $scope.pdf = pdf;
        $scope.completed = completed;
        $scope.saving = saving;
        $scope.defaultGroup = defaultGroup;
        $scope.fromGridEditButton = fromGridEditButton;
        $scope.groupForms = groupForms;
        $scope.validationSuccess = false;
        $scope.validationMessage = null;

        // deep copy of the original group for reverting
        if (fromGridEditButton) {
            var originalGroup = angular.copy(group);
        }

        $scope.closeModal = function (validate) {
            // We need to fake some form validation in the modal
            // this will make sure the form is valid before closing the modal
            if (validate) {
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                var form = $scope.groupForms[group.id];
                if (form != null && form.$valid) {
                    $scope.validationSuccess = true;
                    $uibModalInstance.close();
                } else {
                    $scope.$broadcast("form:submit");
                    $scope.validationMessage = "The form did not pass validation, required information is missing.";
                    $scope.validationSuccess = false;

                    // Scroll to the validation message element
                    var validationMessageElement = $document[0].getElementById('modalFormValidationMessage');
                    if (validationMessageElement) {
                        validationMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }
            if (!validate) {
                $uibModalInstance.close();
            }
        }

        $scope.removeFromList = function (group) {
            //this will go back the the first modal result function (handledRes)
            if (!fromGridEditButton) {
                // only actually remove the item on close from new item
                $uibModalInstance.close({ group: group, message: 'removeFromList' });
            }
            else {
                // if opened from grid edit, revert changes
                if (fromGridEditButton) {
                    angular.copy(originalGroup, $scope.group);
                }
                $uibModalInstance.close();
            }
        }

        // Handle ESC key press
        var escKeyListener = function (event) {
            if (event.keyCode === 27) { // ESC key code
                $scope.$apply(function () {
                    // this will go to the second modal result function (unhandledRes)
                    // we are trying to control what happens when esc is pressed
                    if (!fromGridEditButton) {
                        // we want to effectively "reset" the group if its not from the grid edit button
                        $uibModalInstance.dismiss({ group: $scope.group, message: 'pressedEsc', remove: true });
                    } else {
                        // we wont remove the group, just revert changes before dismissing
                        angular.copy(originalGroup, $scope.group);
                        $uibModalInstance.dismiss({ group: $scope.group, message: 'pressedEsc', remove: false });
                    }
                });
            }
        };

        $document.on('keydown', escKeyListener);

        $scope.$on('$destroy', function () {
            $document.off('keydown', escKeyListener); // Remove the event listener
        });
    }]);